import { Text } from "@/elements";
import BlockAndS3Img from "public/block-and-s3/block_storage.png";

export const INTRO_CONSTANTS = {
  title: "Enterprise Cloud Storage, Built for Scale",
  description: [
    "Cloud storage allows organizations to store and access data over the internet, eliminating the need for physical infrastructure while enabling agility, scalability, and resilience.",
    "OneMind offers two powerful, enterprise-grade cloud storage solutions designed for modern workloads:",
  ],
  points: [
    "Block Storage : High-speed, low-latency storage ideal for databases, virtual machines, and AI-driven applications—built for performance where every millisecond counts.",
    "S3-Compatible Object Storage : Scalable and flexible storage for AI/ML datasets, media content, backups, and large-scale data archives—fully compatible with industry-standard S3 protocols.",
  ],
  children: (
    <Text color="text.100" variant={"body2"}>
      With 99.99% uptime, multi-region redundancy, and enterprise-grade security,
      OneMind’s cloud storage solutions ensure your data is always available, protected,
      and ready to scale as your needs evolve.
    </Text>
  ),
  conclusion:
    "No hardware. No limits. Just seamless, high-performance storage—managed by OneMind.",
  image: BlockAndS3Img,
};
